-- | GENERATED by tools/sync-coverage.mjs - do not edit.
-- |
-- | Source: data/es-verb-coverage.csv (760 cells: 478 drill, 133 later, 149 skip),
-- | which is generated in turn by tools/verb-coverage.mjs.
module Flashcards.Data.Coverage.Spanish
  ( coverage
  )
  where

import Flashcards.Verbs.Coverage (Recommend(..), Verdict)
import Flashcards.Verbs.Table (Person(..), Tense(..))

-- | One entry per cell of the conjugation table, in its order: grouped by
-- | verb, then tense, then person.
coverage :: Array Verdict
coverage =
  [ { infinitive: "ser", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "ser", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "ser", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "ser", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "ser", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "ser", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "ser", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "ser", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "ser", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "ser", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "ser", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "ser", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "ser", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "ser", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "ser", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "ser", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "ser", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "ser", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "ser", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "ser", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "estar", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "estar", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "estar", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "estar", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "estar", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "estar", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "estar", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "estar", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "estar", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "estar", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "estar", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "estar", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "estar", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "estar", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "estar", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "estar", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "estar", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "estar", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "estar", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "estar", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "ir", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "ir", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "ir", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "ir", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "ir", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "ir", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "ir", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "ir", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "ir", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "ir", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "ir", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "ir", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "ir", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "ir", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "ir", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "ir", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "ir", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "ir", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "ir", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "ir", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "tener", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "tener", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "tener", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "tener", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "tener", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "tener", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "tener", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "tener", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "tener", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "tener", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "tener", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "tener", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "tener", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "tener", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "tener", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "tener", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "tener", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "tener", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "tener", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "tener", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "hacer", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "hacer", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "hacer", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "hacer", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "hacer", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "hacer", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "hacer", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "hacer", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "hacer", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "hacer", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "hacer", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "hacer", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "hacer", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "hacer", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "hacer", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "hacer", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "hacer", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "hacer", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "hacer", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "hacer", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "poder", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "poder", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "poder", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "poder", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "poder", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "poder", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "poder", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "poder", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "poder", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "poder", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "poder", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "poder", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "poder", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "poder", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "poder", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "poder", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "poder", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "poder", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "poder", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "poder", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "decir", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "decir", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "decir", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "decir", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "decir", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "decir", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "decir", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "decir", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "decir", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "decir", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "decir", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "decir", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "decir", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "decir", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "decir", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "decir", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "decir", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "decir", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "decir", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "decir", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "poner", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "poner", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "poner", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "poner", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "poner", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "poner", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "poner", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "poner", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "poner", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "poner", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "poner", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "poner", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "poner", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "poner", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "poner", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "poner", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "poner", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "poner", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "poner", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "poner", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "venir", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "venir", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "venir", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "venir", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "venir", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "venir", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "venir", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "venir", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "venir", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "venir", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "venir", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "venir", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "venir", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "venir", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "venir", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "venir", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "venir", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "venir", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "venir", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "venir", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "querer", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "querer", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "querer", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "querer", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "querer", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "querer", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "querer", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "querer", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "querer", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "querer", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "querer", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "querer", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "querer", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "querer", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "querer", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "querer", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "querer", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "querer", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "querer", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "querer", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "saber", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "saber", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "saber", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "saber", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "saber", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "saber", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "saber", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "saber", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "saber", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "saber", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "saber", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "saber", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "saber", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "saber", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "saber", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "saber", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "saber", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "saber", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "saber", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "saber", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "ver", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "ver", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "ver", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "ver", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "ver", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "ver", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "ver", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "ver", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "ver", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "ver", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "ver", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "ver", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "ver", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "ver", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "ver", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "ver", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "ver", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "ver", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "ver", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "ver", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "dar", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "dar", tense: Present, person: Sg2, recommend: Skip }
  , { infinitive: "dar", tense: Present, person: Sg3, recommend: Skip }
  , { infinitive: "dar", tense: Present, person: Pl1, recommend: Skip }
  , { infinitive: "dar", tense: Present, person: Pl3, recommend: Skip }
  , { infinitive: "dar", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "dar", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "dar", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "dar", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "dar", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "dar", tense: Imperfect, person: Sg1, recommend: Skip }
  , { infinitive: "dar", tense: Imperfect, person: Sg2, recommend: Skip }
  , { infinitive: "dar", tense: Imperfect, person: Sg3, recommend: Skip }
  , { infinitive: "dar", tense: Imperfect, person: Pl1, recommend: Skip }
  , { infinitive: "dar", tense: Imperfect, person: Pl3, recommend: Skip }
  , { infinitive: "dar", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "dar", tense: Subjunctive, person: Sg2, recommend: Skip }
  , { infinitive: "dar", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "dar", tense: Subjunctive, person: Pl1, recommend: Skip }
  , { infinitive: "dar", tense: Subjunctive, person: Pl3, recommend: Skip }
  , { infinitive: "salir", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "salir", tense: Present, person: Sg2, recommend: Skip }
  , { infinitive: "salir", tense: Present, person: Sg3, recommend: Skip }
  , { infinitive: "salir", tense: Present, person: Pl1, recommend: Skip }
  , { infinitive: "salir", tense: Present, person: Pl3, recommend: Skip }
  , { infinitive: "salir", tense: Preterite, person: Sg1, recommend: Skip }
  , { infinitive: "salir", tense: Preterite, person: Sg2, recommend: Skip }
  , { infinitive: "salir", tense: Preterite, person: Sg3, recommend: Skip }
  , { infinitive: "salir", tense: Preterite, person: Pl1, recommend: Skip }
  , { infinitive: "salir", tense: Preterite, person: Pl3, recommend: Skip }
  , { infinitive: "salir", tense: Imperfect, person: Sg1, recommend: Skip }
  , { infinitive: "salir", tense: Imperfect, person: Sg2, recommend: Skip }
  , { infinitive: "salir", tense: Imperfect, person: Sg3, recommend: Skip }
  , { infinitive: "salir", tense: Imperfect, person: Pl1, recommend: Skip }
  , { infinitive: "salir", tense: Imperfect, person: Pl3, recommend: Skip }
  , { infinitive: "salir", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "salir", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "salir", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "salir", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "salir", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "traer", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "traer", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "traer", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "traer", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "traer", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "traer", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "traer", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "traer", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "traer", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "traer", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "traer", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "traer", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "traer", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "traer", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "traer", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "traer", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "traer", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "traer", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "traer", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "traer", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "caber", tense: Present, person: Sg1, recommend: Later }
  , { infinitive: "caber", tense: Present, person: Sg2, recommend: Later }
  , { infinitive: "caber", tense: Present, person: Sg3, recommend: Later }
  , { infinitive: "caber", tense: Present, person: Pl1, recommend: Later }
  , { infinitive: "caber", tense: Present, person: Pl3, recommend: Later }
  , { infinitive: "caber", tense: Preterite, person: Sg1, recommend: Later }
  , { infinitive: "caber", tense: Preterite, person: Sg2, recommend: Later }
  , { infinitive: "caber", tense: Preterite, person: Sg3, recommend: Later }
  , { infinitive: "caber", tense: Preterite, person: Pl1, recommend: Later }
  , { infinitive: "caber", tense: Preterite, person: Pl3, recommend: Later }
  , { infinitive: "caber", tense: Imperfect, person: Sg1, recommend: Later }
  , { infinitive: "caber", tense: Imperfect, person: Sg2, recommend: Later }
  , { infinitive: "caber", tense: Imperfect, person: Sg3, recommend: Later }
  , { infinitive: "caber", tense: Imperfect, person: Pl1, recommend: Later }
  , { infinitive: "caber", tense: Imperfect, person: Pl3, recommend: Later }
  , { infinitive: "caber", tense: Subjunctive, person: Sg1, recommend: Later }
  , { infinitive: "caber", tense: Subjunctive, person: Sg2, recommend: Later }
  , { infinitive: "caber", tense: Subjunctive, person: Sg3, recommend: Later }
  , { infinitive: "caber", tense: Subjunctive, person: Pl1, recommend: Later }
  , { infinitive: "caber", tense: Subjunctive, person: Pl3, recommend: Later }
  , { infinitive: "valer", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "valer", tense: Present, person: Sg2, recommend: Skip }
  , { infinitive: "valer", tense: Present, person: Sg3, recommend: Skip }
  , { infinitive: "valer", tense: Present, person: Pl1, recommend: Skip }
  , { infinitive: "valer", tense: Present, person: Pl3, recommend: Skip }
  , { infinitive: "valer", tense: Preterite, person: Sg1, recommend: Skip }
  , { infinitive: "valer", tense: Preterite, person: Sg2, recommend: Skip }
  , { infinitive: "valer", tense: Preterite, person: Sg3, recommend: Skip }
  , { infinitive: "valer", tense: Preterite, person: Pl1, recommend: Skip }
  , { infinitive: "valer", tense: Preterite, person: Pl3, recommend: Skip }
  , { infinitive: "valer", tense: Imperfect, person: Sg1, recommend: Skip }
  , { infinitive: "valer", tense: Imperfect, person: Sg2, recommend: Skip }
  , { infinitive: "valer", tense: Imperfect, person: Sg3, recommend: Skip }
  , { infinitive: "valer", tense: Imperfect, person: Pl1, recommend: Skip }
  , { infinitive: "valer", tense: Imperfect, person: Pl3, recommend: Skip }
  , { infinitive: "valer", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "valer", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "valer", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "valer", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "valer", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "oír", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "oír", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "oír", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "oír", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "oír", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "oír", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "oír", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "oír", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "oír", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "oír", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "oír", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "oír", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "oír", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "oír", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "oír", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "oír", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "oír", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "oír", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "oír", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "oír", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "conducir", tense: Present, person: Sg1, recommend: Later }
  , { infinitive: "conducir", tense: Present, person: Sg2, recommend: Later }
  , { infinitive: "conducir", tense: Present, person: Sg3, recommend: Later }
  , { infinitive: "conducir", tense: Present, person: Pl1, recommend: Later }
  , { infinitive: "conducir", tense: Present, person: Pl3, recommend: Later }
  , { infinitive: "conducir", tense: Preterite, person: Sg1, recommend: Later }
  , { infinitive: "conducir", tense: Preterite, person: Sg2, recommend: Later }
  , { infinitive: "conducir", tense: Preterite, person: Sg3, recommend: Later }
  , { infinitive: "conducir", tense: Preterite, person: Pl1, recommend: Later }
  , { infinitive: "conducir", tense: Preterite, person: Pl3, recommend: Later }
  , { infinitive: "conducir", tense: Imperfect, person: Sg1, recommend: Later }
  , { infinitive: "conducir", tense: Imperfect, person: Sg2, recommend: Later }
  , { infinitive: "conducir", tense: Imperfect, person: Sg3, recommend: Later }
  , { infinitive: "conducir", tense: Imperfect, person: Pl1, recommend: Later }
  , { infinitive: "conducir", tense: Imperfect, person: Pl3, recommend: Later }
  , { infinitive: "conducir", tense: Subjunctive, person: Sg1, recommend: Later }
  , { infinitive: "conducir", tense: Subjunctive, person: Sg2, recommend: Later }
  , { infinitive: "conducir", tense: Subjunctive, person: Sg3, recommend: Later }
  , { infinitive: "conducir", tense: Subjunctive, person: Pl1, recommend: Later }
  , { infinitive: "conducir", tense: Subjunctive, person: Pl3, recommend: Later }
  , { infinitive: "pensar", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "pensar", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "pensar", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "pensar", tense: Present, person: Pl1, recommend: Skip }
  , { infinitive: "pensar", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "pensar", tense: Preterite, person: Sg1, recommend: Skip }
  , { infinitive: "pensar", tense: Preterite, person: Sg2, recommend: Skip }
  , { infinitive: "pensar", tense: Preterite, person: Sg3, recommend: Skip }
  , { infinitive: "pensar", tense: Preterite, person: Pl1, recommend: Skip }
  , { infinitive: "pensar", tense: Preterite, person: Pl3, recommend: Skip }
  , { infinitive: "pensar", tense: Imperfect, person: Sg1, recommend: Skip }
  , { infinitive: "pensar", tense: Imperfect, person: Sg2, recommend: Skip }
  , { infinitive: "pensar", tense: Imperfect, person: Sg3, recommend: Skip }
  , { infinitive: "pensar", tense: Imperfect, person: Pl1, recommend: Skip }
  , { infinitive: "pensar", tense: Imperfect, person: Pl3, recommend: Skip }
  , { infinitive: "pensar", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "pensar", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "pensar", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "pensar", tense: Subjunctive, person: Pl1, recommend: Skip }
  , { infinitive: "pensar", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "volver", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "volver", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "volver", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "volver", tense: Present, person: Pl1, recommend: Skip }
  , { infinitive: "volver", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "volver", tense: Preterite, person: Sg1, recommend: Skip }
  , { infinitive: "volver", tense: Preterite, person: Sg2, recommend: Skip }
  , { infinitive: "volver", tense: Preterite, person: Sg3, recommend: Skip }
  , { infinitive: "volver", tense: Preterite, person: Pl1, recommend: Skip }
  , { infinitive: "volver", tense: Preterite, person: Pl3, recommend: Skip }
  , { infinitive: "volver", tense: Imperfect, person: Sg1, recommend: Skip }
  , { infinitive: "volver", tense: Imperfect, person: Sg2, recommend: Skip }
  , { infinitive: "volver", tense: Imperfect, person: Sg3, recommend: Skip }
  , { infinitive: "volver", tense: Imperfect, person: Pl1, recommend: Skip }
  , { infinitive: "volver", tense: Imperfect, person: Pl3, recommend: Skip }
  , { infinitive: "volver", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "volver", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "volver", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "volver", tense: Subjunctive, person: Pl1, recommend: Skip }
  , { infinitive: "volver", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "pedir", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "pedir", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "pedir", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "pedir", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "pedir", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "pedir", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "pedir", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "pedir", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "pedir", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "pedir", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "pedir", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "pedir", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "pedir", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "pedir", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "pedir", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "pedir", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "pedir", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "pedir", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "pedir", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "pedir", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "dormir", tense: Present, person: Sg1, recommend: Later }
  , { infinitive: "dormir", tense: Present, person: Sg2, recommend: Later }
  , { infinitive: "dormir", tense: Present, person: Sg3, recommend: Later }
  , { infinitive: "dormir", tense: Present, person: Pl1, recommend: Later }
  , { infinitive: "dormir", tense: Present, person: Pl3, recommend: Later }
  , { infinitive: "dormir", tense: Preterite, person: Sg1, recommend: Later }
  , { infinitive: "dormir", tense: Preterite, person: Sg2, recommend: Later }
  , { infinitive: "dormir", tense: Preterite, person: Sg3, recommend: Later }
  , { infinitive: "dormir", tense: Preterite, person: Pl1, recommend: Later }
  , { infinitive: "dormir", tense: Preterite, person: Pl3, recommend: Later }
  , { infinitive: "dormir", tense: Imperfect, person: Sg1, recommend: Later }
  , { infinitive: "dormir", tense: Imperfect, person: Sg2, recommend: Later }
  , { infinitive: "dormir", tense: Imperfect, person: Sg3, recommend: Later }
  , { infinitive: "dormir", tense: Imperfect, person: Pl1, recommend: Later }
  , { infinitive: "dormir", tense: Imperfect, person: Pl3, recommend: Later }
  , { infinitive: "dormir", tense: Subjunctive, person: Sg1, recommend: Later }
  , { infinitive: "dormir", tense: Subjunctive, person: Sg2, recommend: Later }
  , { infinitive: "dormir", tense: Subjunctive, person: Sg3, recommend: Later }
  , { infinitive: "dormir", tense: Subjunctive, person: Pl1, recommend: Later }
  , { infinitive: "dormir", tense: Subjunctive, person: Pl3, recommend: Later }
  , { infinitive: "jugar", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "jugar", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "jugar", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "jugar", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "jugar", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "jugar", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "jugar", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "jugar", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "jugar", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "jugar", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "jugar", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "jugar", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "jugar", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "jugar", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "jugar", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "jugar", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "jugar", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "jugar", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "jugar", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "jugar", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "llegar", tense: Present, person: Sg1, recommend: Skip }
  , { infinitive: "llegar", tense: Present, person: Sg2, recommend: Skip }
  , { infinitive: "llegar", tense: Present, person: Sg3, recommend: Skip }
  , { infinitive: "llegar", tense: Present, person: Pl1, recommend: Skip }
  , { infinitive: "llegar", tense: Present, person: Pl3, recommend: Skip }
  , { infinitive: "llegar", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "llegar", tense: Preterite, person: Sg2, recommend: Skip }
  , { infinitive: "llegar", tense: Preterite, person: Sg3, recommend: Skip }
  , { infinitive: "llegar", tense: Preterite, person: Pl1, recommend: Skip }
  , { infinitive: "llegar", tense: Preterite, person: Pl3, recommend: Skip }
  , { infinitive: "llegar", tense: Imperfect, person: Sg1, recommend: Skip }
  , { infinitive: "llegar", tense: Imperfect, person: Sg2, recommend: Skip }
  , { infinitive: "llegar", tense: Imperfect, person: Sg3, recommend: Skip }
  , { infinitive: "llegar", tense: Imperfect, person: Pl1, recommend: Skip }
  , { infinitive: "llegar", tense: Imperfect, person: Pl3, recommend: Skip }
  , { infinitive: "llegar", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "llegar", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "llegar", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "llegar", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "llegar", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "buscar", tense: Present, person: Sg1, recommend: Skip }
  , { infinitive: "buscar", tense: Present, person: Sg2, recommend: Skip }
  , { infinitive: "buscar", tense: Present, person: Sg3, recommend: Skip }
  , { infinitive: "buscar", tense: Present, person: Pl1, recommend: Skip }
  , { infinitive: "buscar", tense: Present, person: Pl3, recommend: Skip }
  , { infinitive: "buscar", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "buscar", tense: Preterite, person: Sg2, recommend: Skip }
  , { infinitive: "buscar", tense: Preterite, person: Sg3, recommend: Skip }
  , { infinitive: "buscar", tense: Preterite, person: Pl1, recommend: Skip }
  , { infinitive: "buscar", tense: Preterite, person: Pl3, recommend: Skip }
  , { infinitive: "buscar", tense: Imperfect, person: Sg1, recommend: Skip }
  , { infinitive: "buscar", tense: Imperfect, person: Sg2, recommend: Skip }
  , { infinitive: "buscar", tense: Imperfect, person: Sg3, recommend: Skip }
  , { infinitive: "buscar", tense: Imperfect, person: Pl1, recommend: Skip }
  , { infinitive: "buscar", tense: Imperfect, person: Pl3, recommend: Skip }
  , { infinitive: "buscar", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "buscar", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "buscar", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "buscar", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "buscar", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "empezar", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "empezar", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "empezar", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "empezar", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "empezar", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "empezar", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "empezar", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "empezar", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "empezar", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "empezar", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "empezar", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "empezar", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "empezar", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "empezar", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "empezar", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "empezar", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "empezar", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "empezar", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "empezar", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "empezar", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "andar", tense: Present, person: Sg1, recommend: Skip }
  , { infinitive: "andar", tense: Present, person: Sg2, recommend: Skip }
  , { infinitive: "andar", tense: Present, person: Sg3, recommend: Skip }
  , { infinitive: "andar", tense: Present, person: Pl1, recommend: Skip }
  , { infinitive: "andar", tense: Present, person: Pl3, recommend: Skip }
  , { infinitive: "andar", tense: Preterite, person: Sg1, recommend: Later }
  , { infinitive: "andar", tense: Preterite, person: Sg2, recommend: Later }
  , { infinitive: "andar", tense: Preterite, person: Sg3, recommend: Later }
  , { infinitive: "andar", tense: Preterite, person: Pl1, recommend: Later }
  , { infinitive: "andar", tense: Preterite, person: Pl3, recommend: Later }
  , { infinitive: "andar", tense: Imperfect, person: Sg1, recommend: Skip }
  , { infinitive: "andar", tense: Imperfect, person: Sg2, recommend: Skip }
  , { infinitive: "andar", tense: Imperfect, person: Sg3, recommend: Skip }
  , { infinitive: "andar", tense: Imperfect, person: Pl1, recommend: Skip }
  , { infinitive: "andar", tense: Imperfect, person: Pl3, recommend: Skip }
  , { infinitive: "andar", tense: Subjunctive, person: Sg1, recommend: Skip }
  , { infinitive: "andar", tense: Subjunctive, person: Sg2, recommend: Skip }
  , { infinitive: "andar", tense: Subjunctive, person: Sg3, recommend: Skip }
  , { infinitive: "andar", tense: Subjunctive, person: Pl1, recommend: Skip }
  , { infinitive: "andar", tense: Subjunctive, person: Pl3, recommend: Skip }
  , { infinitive: "caer", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "caer", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "caer", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "caer", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "caer", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "caer", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "caer", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "caer", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "caer", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "caer", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "caer", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "caer", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "caer", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "caer", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "caer", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "caer", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "caer", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "caer", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "caer", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "caer", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "conocer", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "conocer", tense: Present, person: Sg2, recommend: Skip }
  , { infinitive: "conocer", tense: Present, person: Sg3, recommend: Skip }
  , { infinitive: "conocer", tense: Present, person: Pl1, recommend: Skip }
  , { infinitive: "conocer", tense: Present, person: Pl3, recommend: Skip }
  , { infinitive: "conocer", tense: Preterite, person: Sg1, recommend: Skip }
  , { infinitive: "conocer", tense: Preterite, person: Sg2, recommend: Skip }
  , { infinitive: "conocer", tense: Preterite, person: Sg3, recommend: Skip }
  , { infinitive: "conocer", tense: Preterite, person: Pl1, recommend: Skip }
  , { infinitive: "conocer", tense: Preterite, person: Pl3, recommend: Skip }
  , { infinitive: "conocer", tense: Imperfect, person: Sg1, recommend: Skip }
  , { infinitive: "conocer", tense: Imperfect, person: Sg2, recommend: Skip }
  , { infinitive: "conocer", tense: Imperfect, person: Sg3, recommend: Skip }
  , { infinitive: "conocer", tense: Imperfect, person: Pl1, recommend: Skip }
  , { infinitive: "conocer", tense: Imperfect, person: Pl3, recommend: Skip }
  , { infinitive: "conocer", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "conocer", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "conocer", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "conocer", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "conocer", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "leer", tense: Present, person: Sg1, recommend: Skip }
  , { infinitive: "leer", tense: Present, person: Sg2, recommend: Skip }
  , { infinitive: "leer", tense: Present, person: Sg3, recommend: Skip }
  , { infinitive: "leer", tense: Present, person: Pl1, recommend: Skip }
  , { infinitive: "leer", tense: Present, person: Pl3, recommend: Skip }
  , { infinitive: "leer", tense: Preterite, person: Sg1, recommend: Skip }
  , { infinitive: "leer", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "leer", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "leer", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "leer", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "leer", tense: Imperfect, person: Sg1, recommend: Skip }
  , { infinitive: "leer", tense: Imperfect, person: Sg2, recommend: Skip }
  , { infinitive: "leer", tense: Imperfect, person: Sg3, recommend: Skip }
  , { infinitive: "leer", tense: Imperfect, person: Pl1, recommend: Skip }
  , { infinitive: "leer", tense: Imperfect, person: Pl3, recommend: Skip }
  , { infinitive: "leer", tense: Subjunctive, person: Sg1, recommend: Skip }
  , { infinitive: "leer", tense: Subjunctive, person: Sg2, recommend: Skip }
  , { infinitive: "leer", tense: Subjunctive, person: Sg3, recommend: Skip }
  , { infinitive: "leer", tense: Subjunctive, person: Pl1, recommend: Skip }
  , { infinitive: "leer", tense: Subjunctive, person: Pl3, recommend: Skip }
  , { infinitive: "construir", tense: Present, person: Sg1, recommend: Later }
  , { infinitive: "construir", tense: Present, person: Sg2, recommend: Later }
  , { infinitive: "construir", tense: Present, person: Sg3, recommend: Later }
  , { infinitive: "construir", tense: Present, person: Pl1, recommend: Later }
  , { infinitive: "construir", tense: Present, person: Pl3, recommend: Later }
  , { infinitive: "construir", tense: Preterite, person: Sg1, recommend: Later }
  , { infinitive: "construir", tense: Preterite, person: Sg2, recommend: Later }
  , { infinitive: "construir", tense: Preterite, person: Sg3, recommend: Later }
  , { infinitive: "construir", tense: Preterite, person: Pl1, recommend: Later }
  , { infinitive: "construir", tense: Preterite, person: Pl3, recommend: Later }
  , { infinitive: "construir", tense: Imperfect, person: Sg1, recommend: Later }
  , { infinitive: "construir", tense: Imperfect, person: Sg2, recommend: Later }
  , { infinitive: "construir", tense: Imperfect, person: Sg3, recommend: Later }
  , { infinitive: "construir", tense: Imperfect, person: Pl1, recommend: Later }
  , { infinitive: "construir", tense: Imperfect, person: Pl3, recommend: Later }
  , { infinitive: "construir", tense: Subjunctive, person: Sg1, recommend: Later }
  , { infinitive: "construir", tense: Subjunctive, person: Sg2, recommend: Later }
  , { infinitive: "construir", tense: Subjunctive, person: Sg3, recommend: Later }
  , { infinitive: "construir", tense: Subjunctive, person: Pl1, recommend: Later }
  , { infinitive: "construir", tense: Subjunctive, person: Pl3, recommend: Later }
  , { infinitive: "reír", tense: Present, person: Sg1, recommend: Later }
  , { infinitive: "reír", tense: Present, person: Sg2, recommend: Later }
  , { infinitive: "reír", tense: Present, person: Sg3, recommend: Later }
  , { infinitive: "reír", tense: Present, person: Pl1, recommend: Later }
  , { infinitive: "reír", tense: Present, person: Pl3, recommend: Later }
  , { infinitive: "reír", tense: Preterite, person: Sg1, recommend: Later }
  , { infinitive: "reír", tense: Preterite, person: Sg2, recommend: Later }
  , { infinitive: "reír", tense: Preterite, person: Sg3, recommend: Later }
  , { infinitive: "reír", tense: Preterite, person: Pl1, recommend: Later }
  , { infinitive: "reír", tense: Preterite, person: Pl3, recommend: Later }
  , { infinitive: "reír", tense: Imperfect, person: Sg1, recommend: Later }
  , { infinitive: "reír", tense: Imperfect, person: Sg2, recommend: Later }
  , { infinitive: "reír", tense: Imperfect, person: Sg3, recommend: Later }
  , { infinitive: "reír", tense: Imperfect, person: Pl1, recommend: Later }
  , { infinitive: "reír", tense: Imperfect, person: Pl3, recommend: Later }
  , { infinitive: "reír", tense: Subjunctive, person: Sg1, recommend: Later }
  , { infinitive: "reír", tense: Subjunctive, person: Sg2, recommend: Later }
  , { infinitive: "reír", tense: Subjunctive, person: Sg3, recommend: Later }
  , { infinitive: "reír", tense: Subjunctive, person: Pl1, recommend: Later }
  , { infinitive: "reír", tense: Subjunctive, person: Pl3, recommend: Later }
  , { infinitive: "seguir", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "seguir", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "seguir", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "seguir", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "seguir", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "seguir", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "seguir", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "seguir", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "seguir", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "seguir", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "seguir", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "seguir", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "seguir", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "seguir", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "seguir", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "seguir", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "seguir", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "seguir", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "seguir", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "seguir", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "sentir", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "sentir", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "sentir", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "sentir", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "sentir", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "sentir", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "sentir", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "sentir", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "sentir", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "sentir", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "sentir", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "sentir", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "sentir", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "sentir", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "sentir", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "sentir", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "sentir", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "sentir", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "sentir", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "sentir", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "morir", tense: Present, person: Sg1, recommend: Drill }
  , { infinitive: "morir", tense: Present, person: Sg2, recommend: Drill }
  , { infinitive: "morir", tense: Present, person: Sg3, recommend: Drill }
  , { infinitive: "morir", tense: Present, person: Pl1, recommend: Drill }
  , { infinitive: "morir", tense: Present, person: Pl3, recommend: Drill }
  , { infinitive: "morir", tense: Preterite, person: Sg1, recommend: Drill }
  , { infinitive: "morir", tense: Preterite, person: Sg2, recommend: Drill }
  , { infinitive: "morir", tense: Preterite, person: Sg3, recommend: Drill }
  , { infinitive: "morir", tense: Preterite, person: Pl1, recommend: Drill }
  , { infinitive: "morir", tense: Preterite, person: Pl3, recommend: Drill }
  , { infinitive: "morir", tense: Imperfect, person: Sg1, recommend: Drill }
  , { infinitive: "morir", tense: Imperfect, person: Sg2, recommend: Drill }
  , { infinitive: "morir", tense: Imperfect, person: Sg3, recommend: Drill }
  , { infinitive: "morir", tense: Imperfect, person: Pl1, recommend: Drill }
  , { infinitive: "morir", tense: Imperfect, person: Pl3, recommend: Drill }
  , { infinitive: "morir", tense: Subjunctive, person: Sg1, recommend: Drill }
  , { infinitive: "morir", tense: Subjunctive, person: Sg2, recommend: Drill }
  , { infinitive: "morir", tense: Subjunctive, person: Sg3, recommend: Drill }
  , { infinitive: "morir", tense: Subjunctive, person: Pl1, recommend: Drill }
  , { infinitive: "morir", tense: Subjunctive, person: Pl3, recommend: Drill }
  , { infinitive: "oler", tense: Present, person: Sg1, recommend: Later }
  , { infinitive: "oler", tense: Present, person: Sg2, recommend: Later }
  , { infinitive: "oler", tense: Present, person: Sg3, recommend: Later }
  , { infinitive: "oler", tense: Present, person: Pl1, recommend: Skip }
  , { infinitive: "oler", tense: Present, person: Pl3, recommend: Later }
  , { infinitive: "oler", tense: Preterite, person: Sg1, recommend: Skip }
  , { infinitive: "oler", tense: Preterite, person: Sg2, recommend: Skip }
  , { infinitive: "oler", tense: Preterite, person: Sg3, recommend: Skip }
  , { infinitive: "oler", tense: Preterite, person: Pl1, recommend: Skip }
  , { infinitive: "oler", tense: Preterite, person: Pl3, recommend: Skip }
  , { infinitive: "oler", tense: Imperfect, person: Sg1, recommend: Skip }
  , { infinitive: "oler", tense: Imperfect, person: Sg2, recommend: Skip }
  , { infinitive: "oler", tense: Imperfect, person: Sg3, recommend: Skip }
  , { infinitive: "oler", tense: Imperfect, person: Pl1, recommend: Skip }
  , { infinitive: "oler", tense: Imperfect, person: Pl3, recommend: Skip }
  , { infinitive: "oler", tense: Subjunctive, person: Sg1, recommend: Later }
  , { infinitive: "oler", tense: Subjunctive, person: Sg2, recommend: Later }
  , { infinitive: "oler", tense: Subjunctive, person: Sg3, recommend: Later }
  , { infinitive: "oler", tense: Subjunctive, person: Pl1, recommend: Skip }
  , { infinitive: "oler", tense: Subjunctive, person: Pl3, recommend: Later }
  , { infinitive: "elegir", tense: Present, person: Sg1, recommend: Later }
  , { infinitive: "elegir", tense: Present, person: Sg2, recommend: Later }
  , { infinitive: "elegir", tense: Present, person: Sg3, recommend: Later }
  , { infinitive: "elegir", tense: Present, person: Pl1, recommend: Later }
  , { infinitive: "elegir", tense: Present, person: Pl3, recommend: Later }
  , { infinitive: "elegir", tense: Preterite, person: Sg1, recommend: Later }
  , { infinitive: "elegir", tense: Preterite, person: Sg2, recommend: Later }
  , { infinitive: "elegir", tense: Preterite, person: Sg3, recommend: Later }
  , { infinitive: "elegir", tense: Preterite, person: Pl1, recommend: Later }
  , { infinitive: "elegir", tense: Preterite, person: Pl3, recommend: Later }
  , { infinitive: "elegir", tense: Imperfect, person: Sg1, recommend: Later }
  , { infinitive: "elegir", tense: Imperfect, person: Sg2, recommend: Later }
  , { infinitive: "elegir", tense: Imperfect, person: Sg3, recommend: Later }
  , { infinitive: "elegir", tense: Imperfect, person: Pl1, recommend: Later }
  , { infinitive: "elegir", tense: Imperfect, person: Pl3, recommend: Later }
  , { infinitive: "elegir", tense: Subjunctive, person: Sg1, recommend: Later }
  , { infinitive: "elegir", tense: Subjunctive, person: Sg2, recommend: Later }
  , { infinitive: "elegir", tense: Subjunctive, person: Sg3, recommend: Later }
  , { infinitive: "elegir", tense: Subjunctive, person: Pl1, recommend: Later }
  , { infinitive: "elegir", tense: Subjunctive, person: Pl3, recommend: Later }
  ]
